export const userIntentValues = {
  Asap: 'asap',
  FewWeeks: 'fewWeeks',
  JustLooking: 'justLooking',
} as const;

export const licensedLawyerValues = {
  Myself: 'Myself',
  SomeoneElse: 'Someone else',
} as const;

export const levelOfExperienceValues = {
  ZeroYears: '0+ years',
  FourYears: '4+ years',
  EightYears: '8+ years',
  TwelveYears: '12+ years',
  FifteenYears: '15+ years',
} as const;

export const levelOfExperienceKeys = {
  ZeroYears: 'ZeroYears',
  FourYears: 'FourYears',
  EightYears: 'EightYears',
  TwelveYears: 'TwelveYears',
  FifteenYears: 'FifteenYears',
} as const;

export const estimatedDurationValues = {
  ONE_MONTH: '1 month',
  TWO_MONTHS: '2 months',
  THREE_MONTHS: '3 months',
  FOUR_MONTHS: '4 months',
  FIVE_MONTHS: '5 months',
  SIX_MONTHS: '6 months',
  SEVEN_MONTHS: '7 months',
  EIGHT_MONTHS: '8 months',
  NINE_MONTHS: '9 months',
  TEN_MONTHS: '10 months',
  ELEVEN_MONTHS: '11 months',
  TWELVE_MONTHS_PLUS: '12 months +',
} as const;

export const estimatedDurationKeys = Object.keys(estimatedDurationValues);
export type EstimatedDuration = keyof typeof estimatedDurationValues;

export const legalTeamSizeValues = {
  One: '1',
  TwoToFive: '2 - 5',
  SixToTen: '6 - 10',
  ElevenToTwenty: '11 - 20',
  TwentyOneToFortyNine: '21 - 49',
  FiftyPlus: '50+',
} as const;
